<template>
  <ul class="feeds-post-info">
    <li class="feeds-post-info__item">
      {{$t('feed.count.day')}}:
      <span class="feeds-post-info__item-count">
        {{dayCountPosts}}
      </span>
    </li>
    <li class="feeds-post-info__item">
      {{$t('feed.count.total')}}:
      <span class="feeds-post-info__item-count">
        {{totalCountPosts}}
     </span>
    </li>
    <li class="feeds-post-info__item">
      {{$t('feed.count.type')}}:
      <span class="feeds-post-info__item-type">{{threadType}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PostInfo",
  props: {
    additional: {
      type: Object,
      required: true
    },
    threadType: {
      type: String
    }
  },
  computed: {
    totalCountPosts() {
      let total = 0;

      for (let key in this.additional.publications) {
        total += parseInt(this.additional.publications[key], 10);
      }

      return total;
    },
    dayCountPosts() {
      let dayCount = 0;
      if (!this.additional.publicationsgrowthdaily) {
        return dayCount;
      }

      const total = this.additional.publicationsgrowthdaily.total;
      const lastOfTotal = total[total.length - 1];

      return lastOfTotal[lastOfTotal.length - 1];
    }
  }
}
</script>

<style>
.feeds-post-info {
  display: flex;
  padding: 0;
  margin: 0 0 9px 0;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  list-style: none;
}

.feeds-post-info__item {
  position: relative;
  padding-right: 10px;
  padding-left: 10px;
}

.feeds-post-info__item:after {
  position: absolute;
  right: 0;
  top: 0;
  font-weight: 700;
  content: "|";
}

.feeds-post-info__item:first-child {
  padding-left: 0;
}

.feeds-post-info__item:last-child:after {
  position: absolute;
  right: 0;
  top: 0;
  font-weight: 700;
  content: "";
}

.feeds-post-info__item-count,  .feeds-post-info__item-type{
  font-weight: 700;
}
</style>
